module.exports = __webpack_public_path__ + "img/sb.cfcff753.svg";